import { createContext } from 'react';
import { QueryResponseElement } from '../../types';

export const teamMemberIdContext = createContext<QueryResponseElement['_id'] | null>(null);
